/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Paths_Compare_DescInputs */

const en_fc_home_paths_compare_desc = /** @type {(inputs: Fc_Home_Paths_Compare_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare cost, workflow, platforms, strengths and limitations with Adobe Premiere Pro.`)
};

/**
* | output |
* | --- |
* | "Compare cost, workflow, platforms, strengths and limitations with Adobe Premiere Pro." |
*
* @param {Fc_Home_Paths_Compare_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_paths_compare_desc = /** @type {((inputs?: Fc_Home_Paths_Compare_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Paths_Compare_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_paths_compare_desc(inputs)
});
export { fc_home_paths_compare_desc as "fc.home.paths.compare.desc" }